import React from "react";

import ServicesHero from "./ServicesHero";
import ServicesList from "./ServicesList";
import ServicesDetails from "./ServicesDetails";
import ServicesIndustries from "./ServicesIndustries";
import ServicesWhyUs from "./ServicesWhyUs";
import ServicesTechStack from "./ServicesTechStack";
import ServicesProcess from "./ServicesProcess";
import ServicesFAQ from "./ServicesFAQ";
import ServicesCTA from "./ServicesCTA";

const Services = () => {
  return (
    <main className="services-page">
      <ServicesHero />
      <ServicesList />
      <ServicesDetails />
      <ServicesIndustries />
      <ServicesWhyUs />
      <ServicesTechStack />
      <ServicesProcess />
      <ServicesFAQ />
      <ServicesCTA />
    </main>
  );
};

export default Services;
